module.exports = __webpack_public_path__ + "img/indexConfiguration.f12e5482.svg";